import { ActionIcon, Indicator, Tooltip } from '@mantine/core'
import { IconFilter } from '@tabler/icons-react'

type FilterHeaderToggleProps = {
  onShowFilters?: () => void
  hasActiveFilters?: boolean
  activeFilterCount?: number
}

export const FilterHeaderToggle = ({
  onShowFilters,
  hasActiveFilters = false,
  activeFilterCount,
}: FilterHeaderToggleProps) => {
  const tooltipLabel =
    hasActiveFilters && activeFilterCount
      ? `Show filters (${activeFilterCount} active)`
      : 'Show filters'

  return (
    <Tooltip label={tooltipLabel} position="bottom" withArrow>
      <Indicator color="blue" size={8} offset={4} disabled={!hasActiveFilters} withBorder>
        <ActionIcon
          variant="default"
          radius="md"
          size="lg"
          onClick={onShowFilters}
          aria-label={tooltipLabel}
        >
          <IconFilter size={18} className="text-slate-600" />
        </ActionIcon>
      </Indicator>
    </Tooltip>
  )
}
